import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import {
  alpha,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

// Animation variants
const buttonVariants = {
  hover: { scale: 1.05, boxShadow: "0 5px 15px rgba(0,0,0,0.1)" },
  tap: { scale: 0.95 },
};

export default function PageHeaderLight({
  title,
  subtitle,
  actions,
  filters,
  expandedFilters,
  toggleFilters,
}) {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 3,
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
      >
        <Box>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {subtitle}
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          {actions.map(({ key, ...props }) => (
            <Button key={key} {...props} sx={{ borderRadius: 2 }} />
          ))}
        </Stack>
      </Stack>

      {/* Collapsible Filters */}
      <AnimatePresence>
        {expandedFilters && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Box
              sx={{
                mt: 3,
                pt: 3,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              {filters}
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Paper>
  );
}
